<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent max-width=850 content-class="round-2xl" scrollable)
  v-card
    v-card-title.px-4
      v-spacer
      .text-xl.font-bold {{ getTitle }}
      v-spacer
      v-btn(icon color="neutral700" @click="closeDialog")
        v-icon mdi-close
    v-divider
    v-card-text.primary--text
      .py-6.px-10
        patient-history-view-details-all(v-if="category === 0" :selectedHistory="selectedHistory" :parentRegistration="parentRegistration")
        patient-history-view-details-diagnosis(v-if="category === 1" :selectedHistory="selectedHistory")
        patient-history-view-details-medication(v-if="category === 2" ref="viewDetailsMedication" :parentRegistration="parentRegistration" :selectedHistory="selectedHistory" :loading="isLoading" :readonly="isFromOtherCompany")
        patient-history-view-details-services(v-if="category === 3" ref="viewDetailsServices" :parentRegistration="parentRegistration" :selectedHistory="selectedHistory" :loading="isLoading" :readonly="isFromOtherCompany")
        patient-history-view-details-documents(v-if="category === 4" :selectedHistory="selectedHistory" :loading="isLoading" :readonly="isFromOtherCompany")
    v-divider
    v-card-actions.px-6
      v-btn.button-md.neutral700--text.px-0.underline(text @click="closeDialog") {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(v-if="!isFromOtherCompany || ![2, 3, 4].includes(category)" :loading="isLoading" depressed dark @click="onClickRightButton") {{ getRightButtonText }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PatientHistoryViewDetailsAll from '@/components/clinic/consultation/patientHistories/PatientHistoryViewDetailsAll.vue'
import PatientHistoryViewDetailsDiagnosis from '@/components/clinic/consultation/patientHistories/PatientHistoryViewDetailsDiagnosis.vue'
import PatientHistoryViewDetailsMedication from '@/components/clinic/consultation/patientHistories/PatientHistoryViewDetailsMedication.vue'
import PatientHistoryViewDetailsServices from '@/components/clinic/consultation/patientHistories/PatientHistoryViewDetailsServices.vue'
import PatientHistoryViewDetailsDocuments from '@/components/clinic/consultation/patientHistories/PatientHistoryViewDetailsDocuments.vue'

export default {
  components: {
    PatientHistoryViewDetailsAll, PatientHistoryViewDetailsDiagnosis, PatientHistoryViewDetailsMedication, PatientHistoryViewDetailsServices, PatientHistoryViewDetailsDocuments
  },
  props: {
    open: {
      type: Boolean,
    },
    selectedHistory: {
      type: Object,
      required: true
    },
    parentRegistration: {
      type: Object,
      required: true
    },
    category: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isLoading: false
    }
  },
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    isFromOtherCompany() {
      return this.selectedHistory?.company?.slug !== this.company?.slug
    },
    leadPid() {
      return this.$route.params.pid
    },
    getTitle() {
      switch (this.category) {
        case 0:
          return this.$t('view_all_details')

        case 1:
          return this.$t('view_diagnosis')

        case 2:
          return this.$t('view_medication_details')

        case 3:
          return 'View services details'

        case 4:
          return this.$t('view_document')
      
        default:
          return ''
      }
    },
    getRightButtonText() {
      return ([2,3].includes(this.category)) ? this.$t('add_to_current_plan') : this.$t('done')
    },
  },
  methods: {
    ...mapActions(['showMessage']),
    closeDialog() {
      this.$emit('cancel')
      this.showDialog = false
    },
    onClickRightButton() {
      if (this.category === 2) {
        this.addToCurrent('medication')
        return
      } else if (this.category === 3) {
        this.addToCurrent('services')
        return
      }
      this.closeDialog()
    },
    async addToCurrent(ref) {
      this.isLoading = true
      try {
        let tempProducts = null
        if (ref === 'medication') {
          tempProducts = this.$refs.viewDetailsMedication.selectedMedications
        } else if (ref === 'services') {
          tempProducts = this.$refs.viewDetailsServices.selectedServices
        }
        await this.$axios.patch(`/leads/${this.leadPid}`, { products: tempProducts })
        this.$emit('updated')
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isLoading = false
      }
    }
  },
}
</script>